import { render } from "./RewardsModal.vue?vue&type=template&id=325bff94&scoped=true"
import script from "./RewardsModal.vue?vue&type=script&lang=js"
export * from "./RewardsModal.vue?vue&type=script&lang=js"

import "./RewardsModal.vue?vue&type=style&index=0&id=325bff94&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-325bff94"]])

export default __exports__